import { render } from "./CategoriesCard.vue?vue&type=template&id=8d7be93a&scoped=true"
import script from "./CategoriesCard.vue?vue&type=script&lang=js"
export * from "./CategoriesCard.vue?vue&type=script&lang=js"

import "./CategoriesCard.vue?vue&type=style&index=0&id=8d7be93a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d7be93a"]])

export default __exports__